import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    whoItem: {
        display: 'flex',
        marginBottom: 0,
        padding: '20px',
        border: '1px solid rgba(3,45,48,.15)',
        borderRadius: '16px',
        backgroundColor: 'hsla(0,0%,100%,.4)',
        
    },
    whoImage: {
        minWidth: '70px',
        minHeight: '70px',
        marginBottom: 'auto',
        marginRight: '15px',
        backgroundImage: 'linear-gradient(180deg,#37715d,#37715d)',
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            maxWidth: '40px',
        }
    },
    whoContent: {
        '& p': {
            marginBottom: 0,
        }
    },
})

function WhoItem(prop) {

    var classes = useStyles()

    return (
        <div className={classes.whoItem + " mb-md-4 mb-3"}>
            <div className={classes.whoImage}>
                <img src={prop.image} alt={prop.heading} />
            </div>
            <div className={classes.whoContent}>
                <h5>{prop.heading}</h5>
                <p>{prop.body}</p>
            </div>
        </div>
    )
}

export default WhoItem
